(()=>{'use strict';window.rageResolveCatalog=function(config){
 const names={black:'Noir Minuit',white:'Blanc Neige',pink:'Rose Bébé'},synonyms={black:['noir','black'],white:['blanc','white'],pink:['rose','pink']};
 const normalize=s=>String(s).trim().toLowerCase();
 const products={},variants={};
 const catalog=[config.product,config.currentProduct,...Object.values(config.products||{}),...(config.catalog||[])].filter(p=>p&&Array.isArray(p.variants)).filter((p,i,all)=>all.findIndex(x=>x.id===p.id)===i);
 const optionColors=v=>Object.keys(names).filter(color=>(v.options||[v.option1,v.option2,v.option3]).some(o=>normalize(o).split(/[^a-zÀ-ÿ]+/).some(word=>synonyms[color].includes(word))));
 const titleHasColor=(product,color)=>String(product.title||'').toLowerCase().split(/[^a-zÀ-ÿ]+/).some(word=>synonyms[color].includes(word));
 for(const color of Object.keys(names)){
   const selected=config.products?.[color],override=String(config.variantIds?.[color]||'').trim();
   const pool=override?catalog:selected?[selected]:catalog;
   let candidates=[];
   for(const product of pool){
     for(const variant of product.variants||[]){
       const hits=optionColors(variant);
       const matches=override?String(variant.id)===override:hits.length?hits.length===1&&hits[0]===color:((selected&&product.variants.length===1)||titleHasColor(product,color));
       if(matches)candidates.push({product,variant});
     }
   }
   // A configured main product takes precedence over auto-discovery, but never over an explicit ID.
   if(!selected&&!override){const main=candidates.filter(pair=>pair.product.id===config.product?.id);if(main.length)candidates=main;}
   const unique=candidates.filter((pair,i,all)=>all.findIndex(other=>String(other.variant.id)===String(pair.variant.id))===i);
   const chosen=unique.length===1?unique[0]:null;products[color]=chosen?.product||selected||null;variants[color]=chosen?.variant||null;
 }
 // Never silently add one variant for two visually different colors.
 const duplicateIds=Object.values(variants).filter(Boolean).map(v=>v.id).filter((id,i,all)=>all.indexOf(id)!==i);
 for(const color of Object.keys(names))if(variants[color]&&duplicateIds.includes(variants[color].id))variants[color]=null;
 return {products,variants,names};
};})();
